<!--
 * @Author: xiaokun
 * @Date: 2020-04-03 10:12:11
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-10 10:04:05
 * @Description: 普通素材设置标签弹窗
 -->

<template>
  <div class="set-tag-dialog">
    <mk-dialog
      :visible="visible"
      title="标签设置"
      width="456px"
      @close="onClose"
    >
      <div class="dialog-content">
        <span class="tag-title">选择标签：</span>
        <!-- 标签多选组件 -->
        <tag-select
          v-model="tagIdList"
          :tip="typeName +'的标签目前仅做分类筛选'"
          :width="343"
          @change="onChange"
        />
      </div>
      <div class="dialog-op">
        <mk-button-biz @click="onClose">
          取 消
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          @click="saveFun"
        >
          保 存
        </mk-button-biz>
      </div>
    </mk-dialog>
  </div>
</template>

<script>
import tagSelect from '@components/tag-select'
export default {
  name: 'SetTagDialog',
  components: {
    tagSelect
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tags: {
      type: Array,
      default: () => []
    },
    //  image(图片)、video(视频)、file(文件)
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tagIdList: []
    }
  },
  computed: {
    typeName () {
      const type = {
        image: '图片',
        video: '视频',
        file: '文件'
      }
      return type[this.type]
    }
  },
  created () {
    this.tagIdList = this.tags
  },
  methods: {
    // 获取当前选择弹窗
    onChange (val) {
      this.tagIdList = val
    },
    /**
     * * 弹窗关闭事件
     */
    onClose () {
      this.tagIdList = []
      this.$emit('update:visible', false)
      this.$emit('on-close')
    },

    /**
     * * 弹窗保存事件
     */
    saveFun () {
      this.$emit('on-confirm', this.tagIdList)
    }
  }
}
</script>
<style lang="scss" scoped>
.set-tag-dialog {
  /deep/ .el-dialog__header {
    .el-dialog__title {
      font-weight: 500;
    }

    .el-dialog__close {
      margin-top: 3px;
    }
  }

  /deep/ .el-dialog__body {
    padding: 0;
  }

  .dialog-content {
    padding: 24px 20px;
    display: flex;

    .tag-title {
      flex-shrink: 0;
      padding-top: 9px;
      line-height: 1;
      font-size: 13px;
    }
  }

  .dialog-op {
    text-align: center;
    border-top: 1px solid #e7e6e9;
    padding: 10px 0;
    width: 100%;

    /deep/ .mk-button-biz {
      padding: 0 15px !important;
    }
  }
}

</style>
